import {
  shape,
  arrayOf,
  number,
  object,
  string,
} from 'prop-types';

export const watchListUpdateLogType = shape({
  id: number.isRequired,
  watchList: object.isRequired,
  createDate: string.isRequired,
});

export const watchListUpdateLogsType = arrayOf(watchListUpdateLogType);


// WEBPACK FOOTER //
// ./src/features/reports/prop-types/watchListUpdateLogType.js